<div class="wrapper">
  <span>{{ data.message || singleReassignMessage }}</span>

  @if (data.bulk && routesExpanded) {
  <div linPerfectScrollbar class="routes-checkbox-list">
    @for (route of data.data; track route.route.id) {
    <mat-checkbox (change)="handleCheckRoute($event.checked, route.route.id)"> {{ getCheckboxText(route) }} </mat-checkbox>
    }
  </div>
  }

  <div class="buttons-wrapper">
    <button [mat-dialog-close]="false" mat-raised-button>{{ 'BUTTONS.CANCEL' | translate | uppercase }}</button>
    @if (!data.bulk) {
    <button [mat-dialog-close]="true" color="accent" mat-raised-button>{{ 'BUTTONS.YES' | translate | uppercase }}</button>
    } @if (data.bulk) {
    <button color="accent" mat-raised-button (click)="reassignBulk('force')">
      {{ 'DIALOGS.ROUTES_BY_VEHICLE.FORCE_REASSIGN' | translate | uppercase }}
    </button>
    } @if (data.bulk) {
    <button
      mat-raised-button
      color="accent"
      [disabled]="routesExpanded && !routesToReassign.size"
      (click)="routesExpanded ? reassignBulk('detailed') : (routesExpanded = true)"
    >
      {{ (routesExpanded ? 'DIALOGS.ROUTES_BY_VEHICLE.DETAILED_REASSIGN' : 'DIALOGS.ROUTES_BY_VEHICLE.EXPAND_ROUTES') | translate |
      uppercase }}
    </button>
    }
  </div>
</div>
